import React, { useEffect, useState } from "react";
import datascience from "../Image/datascience.jpg";
import { UserAuth } from '../Firebase/authcontext';
import styled from "styled-components";
import { db } from "../Firebase/firebase";
import { collection, query, where, getDocs } from "firebase/firestore";

function Left_bar() {
    const { logOut, user } = UserAuth();
    const [friendCount, setFriendCount] = useState(0);

    useEffect(() => {
        const fetchUserData = async () => {
            if (user?.uid) {
                const q = query(collection(db, "User"), where("uid", "==", user.uid));
                const querySnapshot = await getDocs(q);
                querySnapshot.forEach((doc) => {
                    const userData = doc.data();
                    setFriendCount(userData.friendId_list?.length || 0);
                });
            }
        };

        fetchUserData();
    }, [user]);

    return (
        <Container>
            <center>
                <ProfileImage src={datascience} alt="Profile background" />
                <UserInfo>
                    <center>
                        <UserAvatar src={user?.photoURL} alt="User avatar" />
                    </center>
                    <UserName>{user?.displayName}</UserName>
                    <Divider />
                </UserInfo>
                <Stats>
                    <Table>
                        <tbody>
                            <tr>
                                <td>Number of Friends</td>
                                <td className="stat-number">{friendCount}</td>
                            </tr>
                        </tbody>
                    </Table>
                </Stats>
                <MyItems>
                    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 16 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2 2v13.5a.5.5 0 0 0 .74.439L8 13.069l5.26 2.87A.5.5 0 0 0 14 15.5V2a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2z"></path>
                    </svg>
                    <span>My Items</span>
                </MyItems>
            </center>
        </Container>
    );
}

export default Left_bar;

const Container = styled.div`
    background: white;
    width: 100%;
    max-width: 400px;
    border-radius: 30px;
    margin: auto;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    @media (max-width: 600px) {
        max-width: 100%;
        padding: 5px;
    }
`;

const ProfileImage = styled.img`
    align-items: center;
    width: 100%;
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
    object-fit: cover;
`;

const UserInfo = styled.div`
    position: relative;
    top: -60px;
    text-align: center;
`;

const UserAvatar = styled.img`
    max-width: 80px;
    border-radius: 50%;
`;

const UserName = styled.h5`
    font-weight: 600;
    margin: 10px 0;
`;

const Divider = styled.div`
    border-bottom: 1px solid #D5D4D4;
    margin: 10px 0;
`;

const Stats = styled.div`
    font-size: 12px;
    color: #718096;
    position: relative;
    top: -50px;
    border-bottom: 1px solid #D5D4D4;
    padding:10px;

    .stat-number {
        color: #3182ce;
        text-align: right;
    }
`;

const Table = styled.table`
    width: 100%;
    margin: auto;
`;

const MyItems = styled.div`
    margin-top: -30px;
    color: #718096;
    font-size: 14px;
    display: flex;
    align-items: center;
    padding: 10px 10px;
    svg {
        margin-right: 5px;
    }
    span {
        position: relative;
        top: -4px;
    }
    @media (max-width: 600px) {
        justify-content: center;
    }
`;
